var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 8C3 6.89688 3.89688 6 5 6H13C14.1031 6 15 6.89688 15 8V16C15 17.1031 14.1031 18 13 18H5C3.89688 18 3 17.1031 3 16V8ZM20.4719 7.11875C20.7969 7.29375 21 7.63125 21 8V16C21 16.3687 20.7969 16.7063 20.4719 16.8813C20.1469 17.0563 19.7531 17.0375 19.4438 16.8313L16.4438 14.8313L16 14.5344V14V10V9.46562L16.4438 9.16875L19.4438 7.16875C19.75 6.96563 20.1437 6.94375 20.4719 7.11875Z","fill":"#1DA1F2"}));
}

Camera.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Camera;

Camera.default = Camera;
